import type { MapGeometry } from "../shared/types";
import { venueMapArchitectureRings } from "./venueMapArchitecture";

/** Source paint stays below architecture and even a zero-height booth. */
export const VENUE_MAP_ARTWORK_HEIGHT = 0.017;
export const VENUE_MAP_ARTWORK_LABEL_HEIGHT = 0.022;

export function venueMapArtworkRings(
  artwork: NonNullable<MapGeometry["artwork"]>[number],
): number[][][] {
  return venueMapArchitectureRings(artwork.polygons);
}
